export default "__VITE_ASSET__1_ZzGj_T__"